import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchDataThunk, makeFetchSlice } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { fetchBillingHistory } from './api'
import {
  BILLING_CHARGES_LIST_REDUCER_NAME,
  GET_BILLING_CHARGES_REDUCER_NAME,
} from './consts'
import { BillingChargeResponse } from './types'

interface ChargesListState {
  data: BillingChargeResponse
}

const initialState: ChargesListState = {
  data: { list: [], hasMore: false },
}

export const billingChargesListSlice = createSlice({
  initialState,
  name: BILLING_CHARGES_LIST_REDUCER_NAME,
  reducers: {
    set: (state, action: PayloadAction<BillingChargeResponse>) => {
      state.data.list = state.data.list.concat(action.payload.list)
      state.data.hasMore = action.payload.hasMore
    },
    init: () => {
      return initialState
    },
  },
})
export const billingChargesListReducer = billingChargesListSlice.reducer
export const billingChargesListActions = billingChargesListSlice.actions

const getBillingChargesSlice = makeFetchSlice<BillingChargeResponse>(
  GET_BILLING_CHARGES_REDUCER_NAME
)

export const getBillingChargesReducer = getBillingChargesSlice.reducer
export const getBillingChargesActions = getBillingChargesSlice.actions

export const fetchBillingChargesThunk = (
  rootDomainId: string,
  recentChargeId: string
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetchDataThunk({
        dispatch,
        actions: getBillingChargesActions,
        asyncFunc: () => fetchBillingHistory(rootDomainId, recentChargeId),
      })
      dispatch(billingChargesListSlice.actions.set(response))
    } catch (error) {
      console.log('Something went wrong while fething Billing History', error)
    }
  }
}
